export interface IAttributeData {
  id: string;
  name: string;
}

export interface IPropertyData {
  id: string;
  name: string;
  customId: string;
}

export interface IVariableData {
  id: string;
  variable: string;
  attribute: IAttributeData;
  property: IPropertyData;
  selectedPosition: string;
  selectedSource: any[];
  selectedValue: any[];
  disableSource: boolean;
  disablePosition: boolean;
  disableValue: boolean;
  isSelected?: boolean
}

export interface ICalculatedPropertyViewData {
  id: string;
  name: string;
  formula: string;
  variables: IVariableData[];
  onSourceDropdown(value: any, index: number): void;
  onSourceDropdownAsPerAttribute(attribute: string, index: number): void;
}

export default class CalculatedPropertyViewData implements ICalculatedPropertyViewData {
  id: string;
  name: string;
  formula: string;
  variables: IVariableData[];

  constructor(id: string, name: string, formula: string, variables: IVariableData[]) {
    this.id = id;
    this.name = name;
    this.formula = formula;
    if (variables === null || variables === undefined) {
      this.variables = [];
    }
    this.variables = variables;
    this.onVariableInit();
  }

  public onVariableInit() {
  }

  public onSourceDropdown(value: any, index: number) {
    if (this.variables.length > 0) {
      if (value[0].label === "Individual") {
        this.variables[index].disablePosition = true;
        this.variables[index].disableValue = true;
      } else if (value[0].label === "Position") {
        this.variables[index].disablePosition = false;
        this.variables[index].disableValue = false;
      } else {
        this.variables[index].disablePosition = true;
        this.variables[index].disableValue = false;
      }

    }
  }

  public onSourceDropdownAsPerAttribute(attribute: string, index: number) {
    if (attribute !== "Measured Property") {
      this.variables[index].disablePosition = true;
      this.variables[index].disableValue = true;
      this.variables[index].disableSource = true;
    }
  }
}


const defaultCalculatedPropertyData = new CalculatedPropertyViewData("", "", "", []);
export { defaultCalculatedPropertyData };
